import { render } from "./VentasView.vue?vue&type=template&id=162631c6"
import script from "./VentasView.vue?vue&type=script&lang=js"
export * from "./VentasView.vue?vue&type=script&lang=js"

import "./VentasView.vue?vue&type=style&index=0&id=162631c6&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__